import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
import Button from 'components/shared/button/button';
import s from 'components/pages/hub/hero.sss';

export default class Hero extends Component {
	componentDidMount() {
		if (this.bgVideo && this.bgVideo.paused) {
			this.bgVideo.play();
		}
	}

	renderBackground(data, client) {
		const {
			src       = {},
			ariaLabel = '',
			alt       = '',
			poster    = {}
		} = data;

		const resolution = client.deviceSize === 'desktop' ? 'desktop' : 'mobile';
		const mediaSrc   = src[resolution];
		const isVideo    = mediaSrc.endsWith('mp4');
		const posterSrc  = poster[resolution] || '';

		return (
			<div class={s.background}>
				{isVideo ?
					<video
						ref={ref => this.bgVideo = ref}
						class={s.video}
						src={mediaSrc}
						autoplay
						muted
						playsinline
						loop
						ariaLabel={ariaLabel}
						crossorigin='anonymous'
						poster={posterSrc}
					/>
					: <img class={s.image} src={mediaSrc} alt={alt} />
				}
			</div>
		);
	}

	render({ data, client }) {
		const {
			title      = '',
			background = {},
			button     = {}
		} = data;

		return (
			<section class={s.wrapper}>
				{this.renderBackground(background, client)}
				<div class={s.content}>
					<HTML class={s.title} tag='h1' markdown>{title}</HTML>
					<Button data={button} client={client} />
				</div>
			</section>
		);
	}
}
